export default __webpack_public_path__ + "static/media/icon_reply.f8a8b645.svg";